// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"38ff5248","453":"5f24dbbf","553":"e16cd4d9","749":"3028e54d","903":"e431f1b4"}[chunkId] + ".chunk.js";
};